import { Card, CardContent } from "@elit-hair/elit-ui";
import { useTranslation } from "react-i18next";

import type { ReachabilitySummary } from "../types/reachability-analysis.types";

type ReachabilitySummaryCardsProps = {
    summary: ReachabilitySummary;
};

export function ReachabilitySummaryCards({ summary }: ReachabilitySummaryCardsProps) {
    const { t } = useTranslation();

    const cards = [
        {
            key: "total",
            label: t("reachability_analysis_total_calls"),
            value: summary.total,
            hint: null,
        },
        {
            key: "reached",
            label: t("reachability_analysis_reached"),
            value: summary.reached,
            hint: null,
        },
        {
            key: "voicemail",
            label: t("answer_status_voicemail"),
            value: summary.voicemail,
            hint: null,
        },
        {
            key: "not_reached",
            label: t("reachability_analysis_not_reached"),
            value: summary.not_reached,
            hint: null,
        },
        {
            key: "reach_rate",
            label: t("reachability_analysis_reach_rate"),
            value: `${summary.reach_rate.toFixed(1)}%`,
            hint: t("reachability_analysis_reach_rate_hint", {
                reached: summary.reached,
                total: summary.total,
            }),
        },
    ] as const;

    return (
        <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-5">
            {cards.map((card) => (
                <Card key={card.key} className="border-border/60 shadow-none">
                    <CardContent className="flex h-full flex-col justify-center gap-1 p-4">
                        <p className="text-xs text-muted-foreground">{card.label}</p>
                        <p className="text-2xl font-semibold tabular-nums leading-none">{card.value}</p>
                        {card.hint ? <p className="text-[11px] text-muted-foreground">{card.hint}</p> : null}
                    </CardContent>
                </Card>
            ))}
        </div>
    );
}
